import { render } from "./SocialSignin.vue?vue&type=template&id=fd2c7bbc&scoped=true"
import script from "./SocialSignin.vue?vue&type=script&lang=ts"
export * from "./SocialSignin.vue?vue&type=script&lang=ts"

import "./SocialSignin.vue?vue&type=style&index=0&id=fd2c7bbc&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-fd2c7bbc"

export default script